<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <div class="main2" style="margin-top:-5px;">
      <div class="title">修改密码</div>
      <div class="main2">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="原密码：" prop="oldPassword">
            <el-input
              v-model="form.oldPassword"
              placeholder="请输入原密码"
              type="password"
            />
          </el-form-item>
          <el-form-item label="新密码：" prop="newPassword">
            <el-input
              v-model="form.newPassword"
              :placeholder="mmts"
              type="password"
            />
            <div class="intensity" v-if="showLevel">
              <span>密码强度</span>
              <span class="level">{{ levelText }}</span>
              <span
                class="line"
                :class="[level.includes('low') ? 'low' : '']"
              ></span>
              <span
                class="line"
                :class="[level.includes('middle') ? 'middle' : '']"
              ></span>
              <span
                class="line"
                :class="[level.includes('high') ? 'high' : '']"
              ></span>
              <span class="waring">不少于{{ minLength }}位</span>
            </div>
          </el-form-item>
          <el-form-item label="确认密码：" prop="confirmPassword">
            <el-input
              v-model="form.confirmPassword"
              placeholder="请确认密码"
              type="password"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              style="width:150px;margin:20px 0 0;border-color:#97c5e9;border-radius:0;"
              @click="submitBefore"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { changePasswordRequest } from "../../../public/js/service";

export default {
  data() {
    // 1.data
    const equalToPassword = (rule, value, callback) => {
      if (this.form.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    const checkPassword = (rule, value, callback) => {
      this.level = [];
      if (!value) {
        this.showLevel = false;
        return callback("密码不能为空");
      }
      if (value.length < this.minLength) {
        this.showLevel = false;
        return callback("密码不少于" + this.minLength + "位");
      }
      this.showLevel = true;
      // 校验是否纯数字
      const regex1 = /^\d+$/;
      // 校验纯小写字母
      const regex2 = /^[a-z]+$/;
      // 校验纯大写字母
      const regex3 = /^[A-Z]+$/;
      const regex4 = /^[~!@#$%^&*()_+|<>,.?/:;'"]+$/;
      if (regex1.test(value)) {
        this.isNum = true;
        this.isLowercase = false;
        this.isHaveCase = false;
        this.level.push("low");
      } else if (regex2.test(value)) {
        this.isLowercase = true;
        this.isNum = false;
        this.isHaveCase = false;
        this.level.push("low");
      } else if (regex3.test(value)) {
        this.isHaveCase = true;
        this.isNum = false;
        this.isLowercase = false;
        this.level.push("low");
      } else if (regex4.test(value)) {
        this.isHaveCase = true;
        this.isNum = false;
        this.isLowercase = false;
        this.level.push("low");
      } else if (/^[\d~!@#$%^&*()_+|<>,.?/:;]+$/.test(value)) {
        this.isHaveCase = false;
        this.isNum = true;
        this.isLowercase = true;
        this.level.push("low");
        this.level.push("middle");
      } else if (/^[a-z~!@#$%^&*()_+|<>,.?/:;]+$/.test(value)) {
        this.isHaveCase = false;
        this.isNum = true;
        this.isLowercase = true;
        this.level.push("low");
        this.level.push("middle");
      } else if (/^[a-z~!@#$%^&*()_+|<>,.?/:;]+$/.test(value)) {
        this.isHaveCase = false;
        this.isNum = true;
        this.isLowercase = true;
        this.level.push("low");
        this.level.push("middle");
      } else if (/^[a-z\d]+$/.test(value)) {
        this.isHaveCase = false;
        this.isNum = true;
        this.isLowercase = true;
        this.level.push("low");
        this.level.push("middle");
      } else if (/^[A-Z\d]+$/.test(value)) {
        this.isHaveCase = true;
        this.isNum = true;
        this.isLowercase = false;
        this.level.push("low");
        this.level.push("middle");
      } else if (/^[A-z]+$/.test(value)) {
        this.isHaveCase = true;
        this.isNum = false;
        this.isLowercase = true;
        this.level.push("low");
        this.level.push("middle");
      } else if (/^[A-z\d]+$/.test(value)) {
        this.isHaveCase = true;
        this.isNum = true;
        this.isLowercase = true;
        this.level.push("low");
        this.level.push("middle");
        this.level.push("high");
      } else if (/^[A-z\d~!@#$%^&*()_+|<>,.?/:;'"]+$/.test(value)) {
        this.isHaveCase = true;
        this.isNum = true;
        this.isLowercase = true;
        this.level.push("low");
        this.level.push("middle");
        this.level.push("high");
      }
      if (this.level.length < 2) {
        //this.showLevel = false;
        return callback("密码太简单");
      }
      return callback();
    };
    return {
      username: "", // 1.1.客户名称
      password: "", // 1.2.原密码
      newPassword: "", // 1.3.新密码
      yesPassword: "", // 1.4.确认密码
      userInfo: {}, // 1.5.userInfo
      timer: null, // 1.6.定时器对象，用于查询用户信息直到查询到位置
      token: "", // 1.7.token
      minLength: 6,
      form: { oldPassword: "", newPassword: "", confirmPassword: "" },
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          {
            required: true,
            validator: checkPassword,
            trigger: ["blur", "change"],
          },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
      },
      levelText: "",
      level: [],
      // 有大写字母？
      isHaveCase: false,
      // 有小写字母?
      isLowercase: false,
      // 有数字？
      isNum: false,
      showLevel: false,
      mmts: "",
    };
  },

  components: {
    // 2.components
  },

  methods: {
    // 3.methods
    submitBefore() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      // 3.3.确认修改
      let data = {
        username: this.userInfo.customerName,
        password: this.form.oldPassword,
        newPassword: this.form.newPassword,
        yesPassword: this.form.confirmPassword,
      };

      changePasswordRequest(data).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });

          this.form = { oldPassword: "", newPassword: "", confirmPassword: "" };
        }
      });
    },
  },

  mounted() {
    // 3.4.mounted
    if (localStorage.token) {
      // 3.4.1.修改密码需要token
      this.token = localStorage.token;
    }

    this.mmts = "密码需包含字母及数字并不能低于" + this.minLength;

    this.timer = setInterval(() => {
      // 3.4.2.修改密码需要用户名
      if (localStorage.userInfo) {
        clearInterval(this.timer);
        this.userInfo = JSON.parse(localStorage.userInfo);
      }
    }, 20);
  },
};
</script>

<style scoped lang="scss">
.gap-line {
  display: flex;
  position: absolute;
  top: 0px;
  left: 45px;
  width: 1px;
  height: 21px;
  background: #d9dadd;
}
/deep/.ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 60px;
  height: 40px;
}
/deep/.ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-left: 60px;
  height: 40px;
}
.mt24 {
  margin-top: 24px;
}
.intensity {
  .line {
    display: inline-block;
    width: 48px;
    height: 4px;
    background: #d8d8d8;
    border-radius: 3px;
    margin-right: 8px;
    &.low {
      background: #f4664a;
    }
    &.middle {
      background: #ffb700;
    }
    &.high {
      background: #2cbb79;
    }
  }
  .level {
    margin: 0 16px 0 8px;
  }
  .waring {
    float: right;
    color: #d9dadd;
    font-size: 12px;
    margin-top: 5px;
  }
}
.type-box {
  margin-top: 16px;
  .type {
    margin-right: 25px;
  }
  .success {
    color: #2cbb79;
    font-size: 14px;
  }
  .error {
    color: #f4664a;
    font-size: 14px;
  }
}
</style>
